//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    Fragment,
    useState,
    useEffect,
    useContext,
    useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';

// custom pages
import Table from 'components/Table/Table';
import SignatureAuditAPI from 'apis/signatureAudit/signatureAudit';
import ServicePlusAuditAPI from 'apis/servicePlusAudit/servicePlusAudit';
import Context from 'context/context';
import searchIcon from 'assets/img/Search_Icon.png';
import { Styles } from './styles';

import { toast } from "react-toastify";
// material-ui
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';

// material-ui icons
import Grid from '@material-ui/core/Grid';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

//Helpers
import useDebounce from 'helpers/useDebounce';
import { blockInvalidChar } from 'helpers/blockInvalidChar';
import { dateFormat } from "helpers/dataFormat"
import * as moment from "moment";
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";

// custom TextField
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '##D3D3D3',
        },
        '& .MuiFormLabel-root': {
            color: '#707070',
        },
        '& .MuiInputBase-input': {
            color: '#707070',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#707070',
            },
            '&:hover fieldset': {
                borderColor: '#707070',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#707070',
            },
            '&.MuiOutlinedInput-root': {
                borderRadius: 20,
            },
            '&.MuiOutlinedInput-root': {
                marginTop: 0,
                borderRadius: 20,
                background: '#ededed',
            },
        },
    },
})(TextField);

export default function SignatureAudit() {
   
    const { getAPI,Export, searchAPI  } = ServicePlusAuditAPI();
    const { state, dispatch } = useContext(Context);
    const classes = Styles();
    const [data, setData] = useState([]);
    
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState('');
    const [exportData, setExportData] = useState([]);
    const { t, i18n } = useTranslation();
        const [response, setResponse] = useState({
        filter: false,
    });


    let searchBounceValues = useDebounce(() => {
        return searchValue === '' ? '' : searchValue;
    });

    // Common State Object
    const [states, setstates] = useState({
        clearSearch: false,
        tier: [],
        reasonDescription: [],
        newTier: "",
        systemManaged: "",
        reason: "",
        editObj: {},
        updateObj: {},
        oldTier: "",
        initiatedBy: "",
        updatedBy: "",
        userDetail: []
    });

    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    const { clearSearch } = states;

    // Page Path Name
    useEffect(() => {
        dispatch({
            type: 'SET_PATHNAME',
            payload: ['HOME', 'ADMIN', 'Audit Service Plus'],
        });        
    }, []);

    // Handling Get and Search API
    useEffect(() => {
        if (!clearSearch) {
            if (searchBounceValues && searchBounceValues.length > 0) {
                handleSearch();
            }
            else {
                getDetails();
            }
        }
        else {
            setStates({ clearSearch: false });
        }
    }, [searchBounceValues, offset]);

    // Get API Func
    async function getDetails() {
        try {
            setLoading(true);
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await getAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false);
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        }
        catch (e) {
            console.log({ e });
        }
    }

   

    // Search API Func
    async function handleSearch() {
        try {
            setLoading(true);
            let values;
            values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
            };            
            setResponse({ ...response, filter: false });
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await searchAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false);
                dispatch({ type: 'SET_LOADING', payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    // Data Table Headings
    let tableHeading = [
        'Member ID',
        'Billto',
        'Shipto',
        'Tier Level',
        'Start Date',
        'End Date',
        'Initiated By',
        'Updated By',
    ];

    // Table Pagination Func
    const handlePagination = (value) => {
        setOffset(value);
    };

    const handleExport = async () => {
        // let values = {};
        // let values = {};
        if (searchValue) {
          values = { ...values, searchValue };
        }
        // setLoading(true)
        let values;
        values = {
            searchValue,
    
            
        };
    
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await Export(values);
      
        if (res && res.data) {
            // setIsLoading(false);
            setExportData(res.data);
            dispatch({ type: "SET_LOADING", payload: false });
           
            if (res.data.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
           
            return true;
          }
        }
    // console.log(state, 'raja')
    return (
        <Fragment>
            <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>
                <div style={{ flex: 0.99 }}>
                    <CssTextField
                        id="search"
                        placeholder="Search for Billto or Shipto ID"
                        onKeyDown={blockInvalidChar}
                        type={"number"}
              onWheel={(e) => e.target.blur()}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setStates({ clearSearch: true });
                                                setSearchValue("");
                                                if (offset === 1) {
                                                    getDetails();
                                                }
                                                else {
                                                    setOffset(1);
                                                }
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            setOffset(1);
                            if (e.target.value.length == 0) {
                                getDetails();
                            }
                        }}
                        onClick={() => { }}
                    />                    
                </div>
                <CSVLink
            id="csv"
            data={exportData.map(item => ({
                ...item,
                service_plus_start_date : item.service_plus_start_date?dateFormat(item.service_plus_start_date, i18n.language)
                : '-',
                service_plus_end_date : item.service_plus_end_date ? dateFormat(item.service_plus_end_date, i18n.language)
                : '-'

              }))}
             headers={exportHeaders}
         filename={
              `Service Plus-Audit` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            // disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>                
            </Grid>           

            <div style={{ marginTop: 20 }}>
                {!loading ? (
                    <Table
                        headings={tableHeading.map((i) => {
                            return <div key={t(i)}>{t(i)}</div>;
                        })}
                        data={
                            data?.map((d, i) => [
                                d?.loyalty_id,
                                d?.customer_billto_account_number,
                                d?.customer_account_number,
                                d?.plan,
                                d?.service_plus_start_date
                                    ? dateFormat(d?.service_plus_start_date, i18n.language)
                                    : '-',
                                d?.service_plus_end_date
                                    ? dateFormat(d?.service_plus_end_date, i18n.language)
                                    : '-',
                                d?.altered_by,
                                d?.user_name,
                            ])
                        }
                        offset={offset}
                        count={
                            (count / 10) % 1 == 0
                                ? Math.floor(count / 10)
                                : Math.floor(count / 10 + 1)
                        }
                        handlePagination={handlePagination}
                    />
                ) : (
                    <div
                        style={{
                            height: '25vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <h2>{t('Loading...')}</h2>
                    </div>
                )}
            </div>
        </Fragment>
    );
}
